import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto h-full" }
const _hoisted_2 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-10 w-10 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex flex-col m-auto items-center w-full px-6 space-y-14 pt-20" }
const _hoisted_6 = { class: "flex flex-col items-center space-y-14" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto text-white text-4xl font-medium" }, "Hello Sweet Stuff", -1)
const _hoisted_8 = { class: "flex flex-col space-y-4 w-full items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "my-auto",
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79 8.87 9.47 8.67L2.4 4.25C2.29973 4.19371 2.21192 4.11766 2.14189 4.02645C2.07186 3.93525 2.02106 3.83078 1.99258 3.71937C1.96409 3.60796 1.9585 3.49194 1.97616 3.37831C1.99381 3.26468 2.03434 3.15581 2.09528 3.0583C2.15623 2.96079 2.23632 2.87666 2.33073 2.811C2.42513 2.74533 2.53187 2.69951 2.6445 2.6763C2.75712 2.65309 2.87328 2.65297 2.98595 2.67595C3.09863 2.69893 3.20546 2.74453 3.3 2.81L10 7L16.7 2.81C16.7945 2.74453 16.9014 2.69893 17.014 2.67595C17.1267 2.65297 17.2429 2.65309 17.3555 2.6763C17.4681 2.69951 17.5749 2.74533 17.6693 2.811C17.7637 2.87666 17.8438 2.96079 17.9047 3.0583C17.9657 3.15581 18.0062 3.26468 18.0238 3.37831C18.0415 3.49194 18.0359 3.60796 18.0074 3.71937C17.9789 3.83078 17.9281 3.93525 17.8581 4.02645C17.7881 4.11766 17.7003 4.19371 17.6 4.25Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, " Continue with email ")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-brand-lime" }, "Sign in", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex py-16 px-12 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-sm text-center" }, [
    /*#__PURE__*/_createTextVNode("By signing up to Pineapple"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("you agree to our "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "font-bold",
      target: "_system",
      href: "https://pineapple-public.s3.eu-west-2.amazonaws.com/terms-of-use-eula.pdf"
    }, "Terms of use (EULA)"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("and "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "font-bold",
      target: "_system",
      href: "https://pineapple-public.s3.eu-west-2.amazonaws.com/app-privacy-policy.pdf"
    }, "Privacy Policy.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_mark = _resolveComponent("logo-mark")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_logo_mark),
                      _hoisted_7
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args))),
                        class: "flex bg-brand-dark-gray rounded-full max-w-md w-full h-14 font-medium text-xl text-white"
                      }, _hoisted_10),
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoLogin && _ctx.gotoLogin(...args))),
                        class: "text-lg text-white"
                      }, [
                        _createTextVNode("Already have an account? "),
                        _hoisted_11
                      ])
                    ])
                  ]),
                  _hoisted_12
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}